import { useYearQuarterNavigation } from 'hooks';
import { useQuery } from 'react-query';
import { useRecoilValue } from 'recoil';

import { getScenarioFlexCapacitySettings } from 'RestAPIs/scenario';

import { scenarioAtom } from '../../atoms';

import { Box } from '@mui/material';

import { LoadingOverlay } from 'components/shared';

import AdditionalCapacityGrid from './components/AdditionalCapacityGrid';
import FlexCapacityAgreements from './components/FlexCapacityAgreements';

import { queryKeys } from './queries';

const BorrowAndLending = () => {
  const scenario = useRecoilValue(scenarioAtom);
  const { year } = useYearQuarterNavigation();

  const { data: flexCapacity, isLoading } = useQuery(
    [queryKeys.SCENARIO_FLEX_CAPACITY_SETTINGS, scenario?.scenarioId, year],
    async () => {
      const { data } = await getScenarioFlexCapacitySettings({
        scenarioId: scenario?.scenarioId as number,
        year
      });

      return data;
    },
    {
      enabled: !!scenario?.scenarioId
    }
  );

  return (
    <Box>
      <LoadingOverlay loading={isLoading} />
      {scenario && !scenario?.readOnly && (
        <FlexCapacityAgreements data={flexCapacity} />
      )}
      <AdditionalCapacityGrid />
    </Box>
  );
};

export default BorrowAndLending;
